import { getQueryStringVariable } from "./getQueryStringVariable";

export function loadSystemCodeFromQueryString() {
	return getQueryStringVariable("system_code") || getQueryStringVariable("systemCode") || null;
}
